import Vue from 'vue'
import App from './App.vue'
import { closest } from './utils/ie'
import router from './router/index'
import i18n from './lang/i18n.js'
import store from './store'

import '@/filters/filters'
import ODS from '@/components/index.js'

closest()
Vue.config.productionTip = false

Vue.use(ODS, {
  i18n: (key, value) => i18n.t(key, value)
})

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
